import { styled } from '@mui/system';
import { Typography, Button } from '@mui/material';

export const MobileRadioContainer = styled('div')(() => ({
  textAlign: 'center'
}));

export const MobileLabel = styled(Typography)(() => ({
  marginTop: '16px',
  marginBottom: '16px',
  textAlign: 'left'
}));

export const ButtonGroup = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center'
}));

const RadioButton = styled(Button)(() => ({
  boxShadow: 'none',
  padding: '10px 20px',
  margin: '0 2px',
  flex: 1
}));

export const RadioButtonLight = styled(RadioButton)(() => ({
  color: 'white'
}));

export const RadioButtonDark = styled(RadioButton)(() => ({
  color: '#00000099'
}));
